import { create } from "zustand";
import { devtools, persist, createJSONStorage } from "zustand/middleware";
import {
  DateTimeFormatEntity,
  DefaultLocationEntity,
  DefaultResourceTypeEntity,
  OrganizerSettingEntity,
  QuickButtonEntity,
  TileConfigurationEntity,
} from "../services/entities/organizerSettingEntity";

export interface AppSettingState extends OrganizerSettingEntity {
  toggleHasAssistant: () => void;
  updateAssistantInfo: (email: string, type: number, name: string) => void;
  updateDefaultResourceType: (type: string) => void;
  updateDefaultLocations: (defaultLocations: DefaultLocationEntity) => void;
  updateDefaultCategories: (categoryIds: string) => void;
  setTileConfiguration: (value: TileConfigurationEntity) => void;
  updateDefaultResourceTypes: (value: DefaultResourceTypeEntity[]) => void;
  updateQuickButtons: (value: QuickButtonEntity[]) => void;
  updateDateTimeFormat: (value: DateTimeFormatEntity) => void;
  updateCapacityFilter: (value: boolean) => void;
}

export const useSettingStore = create<AppSettingState>()(
  devtools(
    persist(
      (set, get) => ({
        ...new OrganizerSettingEntity(),

        // assistant
        toggleHasAssistant: () => set({ hasAssistant: !get().hasAssistant, assistantEmail: "", assistantType: 0 }),
        updateAssistantInfo: (email: string, type: number, name: string) => set({ assistantEmail: email, assistantType: type, assistantName: name }),

        // default resource type
        updateDefaultResourceType: (type: string) => set({ defaultResourceType: type }),

        // default locations
        updateDefaultLocations: (defaultLocations: DefaultLocationEntity) =>
          set({ defaultLocations: defaultLocations }),

        // default categories
        updateDefaultCategories: (categoryIds: string) =>
          set({ defaultCategoryIds: categoryIds }),

        // default resource types
        updateDefaultResourceTypes: (value: DefaultResourceTypeEntity[]) =>
          set({
            defaultLocations: {
              defaultLocationIds: get().defaultLocations.defaultLocationIds,
              defaultResourceTypes: value,
            },
          }),

        // quick buttons
        updateQuickButtons: (value: QuickButtonEntity[]) => set({ quickButtons: value }),

        // tile configuration
        setTileConfiguration: (value) => set({ tileConfiguration: value }),

        // date time format
        updateDateTimeFormat: (value: DateTimeFormatEntity) => set({ dateTimeFormat: value, firstDayOfWeek: value.firstDayOfWeek, dateFormat: value.dateFormat, timeFormat: value.timeFormat, dateSeparator: value.dateSeparator }),

        // capacity filter
        updateCapacityFilter: (value: boolean) => set({ capacityFilter: value }),
      }),
      {
        name: "outlook-addin-setting-store",
        version: 1,
        storage: createJSONStorage(() =>
          typeof window !== "undefined"
            ? localStorage
            : {
              length: 0,
              clear() { },
              getItem() {
                return null;
              },
              key() {
                return null;
              },
              removeItem() { },
              setItem() { },
            }
        ),
        partialize: (state) => ({
          tileConfiguration: state.tileConfiguration,
        }),
      }
    )
  )
);
